<div class="rounded-3xl border border-dashed border-tilled-secondary-600 bg-tilled-neutral-100">
  <ng-content></ng-content>
</div>
